import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32b52b88&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/components/wechat/css/wechat.less?vue&type=style&index=0&id=32b52b88&lang=less&scoped=true&external"
import style1 from "@/components/wechat/css/wechat.scss?vue&type=style&index=1&id=32b52b88&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b52b88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b52b88')) {
      api.createRecord('32b52b88', component.options)
    } else {
      api.reload('32b52b88', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32b52b88&scoped=true", function () {
      api.rerender('32b52b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wx-menu/index.vue"
export default component.exports